<div class="svg-container w-full h-0 overflow-hidden">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 185">
        <path
            fill="currentColor"
            d="M0,1369.05432 C276.659548,1367.97445 536.379397,1382.99581 779.159548,1414.11838 C1021.9397,1445.24095 1242.21985,1491.75196 1440,1553.6514 L1440,1554 L0,1554 L0,1369.05432 Z"
            transform="matrix(1 0 0 -1 0 1554)"
        />
    </svg>
    <div
        class="background absolute bg-current inset-0"
        [class.above]="direction && direction[1] === 'up'"
        [class.below]="direction && direction[1] === 'down'"
    ></div>
</div>
